import { render, staticRenderFns } from "./ApplicationSelectChild.vue?vue&type=template&id=483c4470&scoped=true&"
import script from "./ApplicationSelectChild.vue?vue&type=script&lang=js&"
export * from "./ApplicationSelectChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483c4470",
  null
  
)

export default component.exports